import React, { useEffect, useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCheck } from "@fortawesome/free-solid-svg-icons";
import carroIcono from "../../../assets/img/truck-icon.png";
import denegadaIcono from "../../../assets/img/cancel.png";
import { CierraVentana } from "../../../helpers/controlSidebarDerecha";
import { Input } from "../../Input";
// import { Select } from "../../Select";
import Select from "react-select";
import { useUnidades } from "../../../hooks/test/useUnidades";
import { SocketContext } from "../../../context/SocketContext";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { Spinner as Load } from "../../Spinner";
import Spinner from "react-bootstrap/Spinner";
import { verifyJWT, verifyJWT2 } from "../../../helpers/JWT";
import { AuthContext } from "../../../context/authContext/authContext";
import { Loader } from "../../Loader";
import { EditCreateTripulante } from "../../customComponents/Modals/ModalCreateEdit";

const ModelFormatoViaje = {
  cedis_id: "",
  chofer_id: "",
  descripcion: "",
  fecha_hora_regreso: "",
  fecha_hora_salida: "",
  status_id: "",
  unidad_id: "",
  viaje_id: "",
  fecha_salida: "",
  hora_salida: "",
};
export const FormatoCheckPruebas = ({ unidad, getUnidades, viaje }) => {
  const { socket } = useContext(SocketContext);
  const [formatoViaje, setFormatoViaje] = useState(ModelFormatoViaje);
  const {
    getTiendasViaje,
    getTripulacionViaje,
    getTiendasNegocio,
    getTiendasCedis,
    postTipulantes,
    deleteTipulantes,
    createRuta,
    deleteRuta,
    putViaje,
    putViajeStatusV2,
    postCheckPrueba,
    getViajeUnidad,
    postBitacora,
    deleteTripulacionViaje,
    postTripulantes,
    postTripulanteViaje,
    postDenegacionViaje,
    getPositionCamiones,
    ejecutarParoMotor,
    getBTNPanico,
    getTripulantesIdNegocio,
    putTripulantes,
    putViajev2,
  } = useUnidades();
  const [cat_tiendas, setCatTiendas] = useState([]);
  const [denegoSalida, setDenegoSalida] = useState(false);
  const [motivoDenegacionSalida, setMotivoDenegacionSalida] = useState("");
  const [destinoSeleccionado] = useState("");
  const [tiendasSeleccionadas, setTiendasSeleccionadas] = useState([]);
  const [status, setStatus] = useState({
    first: false,
    second: false,
    third: false,
  });
  const [loading, setLoading] = useState([]);
  const { user } = useContext(AuthContext);
  const [ejecutarPruebas, setEjecutarPruebas] = useState(false);
  const [paroMotorOn, setParoMotorOn] = useState("");
  const [paroMotorOff, setParoMotorOff] = useState("");
  const [panico, setPanico] = useState("");
  const [gps, setGps] = useState("");
  const [paroMotorOffEjecutado, setParoMotorOffEjecutado] = useState(false);
  const [paroMotorOnEjecutado, setParoMotorOnEjecutado] = useState(false);
  const [panicoEjecutado, setPanicoEjecutado] = useState(false);
  const [gpsEjecutado, setGpsEjecutado] = useState(false);
  const [loadingPosition, setLoadingPosition] = useState(false);
  const [loadingParoMotorOn, setLoadingParoMotorOn] = useState(false);
  const [loadingParoMotorOff, setLoadingParoMotorOff] = useState(false);
  const [loadingPanico, setLoadingPanico] = useState(false);
  const [habilitado, setHabilitado] = useState(true);

  const [tripulantes, setTripulantes] = useState([]);
  const [tripulacionSeleccionada, setTripulacionSeleccionada] = useState([]);
  const [showModalCrud, setShowModalCrud] = useState(false);
  const [tiendasPendientes, setTiendasPendientes] = useState([]);

  useEffect(() => {
    if (viaje.viaje_id) {

      setFormatoViaje({
        ...formatoViaje,
        fecha_salida: viaje.fecha_hora_salida
          ? viaje.fecha_hora_salida.substring(0, 10)
          : "0000-00-00",
        hora_salida: viaje.fecha_hora_salida
          ? viaje.fecha_hora_salida.substring(11, 16)
          : "0000-00-00",
        ...viaje,
      });

      getInfoViaje(viaje.viaje_id);
    }
  }, [viaje]);
  /**
   *
   * @param {*} viaje_id
   */
  const getInfoViaje = async (viaje_id) => {
    setLoading(true);

    let resp = await getTiendasViaje(viaje_id);
    if (resp.ok) {
      setTiendasSeleccionadas(resp.rutas);
    }
    const tripulacionMapeada = viaje.tripulantes_viajes.map(t => ({
      tripulante_id: t.tripulante_id,
      nombre: t.tripulante?.nombre_completo || "",
      telefono: t.tripulante?.telefono || "",
      rol: "TRIPULANTE", // los del viaje ya son tripulantes
      tipo_tripulante_id: 2,
    }));

    // Agregar operador y chofer del viaje si existen
    const operadoresMapeados = [];
    if (viaje.chofer) {
      operadoresMapeados.push({
        tripulante_id: viaje.chofer.tripulante_id,
        nombre: viaje.chofer.nombre_completo,
        telefono: viaje.chofer.telefono,
        rol: "OPERADOR",
        tipo_tripulante_id: 1,
      });
    }
    if (viaje.operador) {
      operadoresMapeados.push({
        tripulante_id: viaje.operador.tripulante_id,
        nombre: viaje.operador.nombre_completo,
        telefono: viaje.operador.telefono,
        rol: "OPERADOR",
        tipo_tripulante_id: 1,
      });
    }

    setTripulacionSeleccionada([...operadoresMapeados, ...tripulacionMapeada]);
    // }
    setLoading(false);
  };
  /**
   *
   */
  useEffect(() => {
    if (!unidad.unidad_id) return;
    setLoading(true);
    loadInfo();
    setLoading(false);
    setParoMotorOn("");
    setParoMotorOff("");
    setPanico("");
    setGps("");
    setParoMotorOffEjecutado(false);
    setParoMotorOnEjecutado(false);
    setPanicoEjecutado(false);
    setGpsEjecutado(false);
    setEjecutarPruebas(false);
    setLoadingPosition(false);
    setLoadingParoMotorOn(false);
    setLoadingParoMotorOff(false);
    setLoadingPanico(false);
    setHabilitado(true);
    setStatus({ first: false, second: false, third: false });
  }, [unidad]);
  /**
   *
   */
  useEffect(() => {
    if (gpsEjecutado) setStatus({ ...status, third: true });
    if (paroMotorOnEjecutado && paroMotorOffEjecutado) setStatus({ ...status, first: true });
    if (panicoEjecutado) setStatus({ ...status, second: true });
  }, [gpsEjecutado, paroMotorOnEjecutado, panicoEjecutado, paroMotorOffEjecutado]);

  const loadInfo = async () => {
    setLoading(true);

    /*Trae las tiendas */
    let resp = [];
    if (unidad.negocio_id !== 1) {
      resp = await getTiendasNegocio(unidad.negocio_id);
    } else {
      resp = await getTiendasCedis(unidad.cedis_id);
    }

    if (resp.ok) {
      setCatTiendas(resp.tiendas);
    } else {
      setCatTiendas([]);
    }
    /*Trae los choferes */

    const respT = await getTripulantesIdNegocio(unidad.negocio_id);
    if (respT.ok) {
      setTripulantes(respT.tripulantes);
    } else {
      setTripulantes([]);
    }

    setLoading(false);
  };

  const handleChange = (event) => {
    setFormatoViaje({
      ...formatoViaje,
      [event.target.name]: event.target.value,
    });
  };

  const agregarTienda = (tienda_id) => {
    setTiendasPendientes(prev => [...prev, tienda_id]);
  };

  const subirTienda = (index) => {
    if (index === 0) return;
    const arr = [...tiendasPendientes];
    [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]];
    setTiendasPendientes(arr);
  };

  const bajarTienda = (index) => {
    if (index === tiendasPendientes.length - 1) return;
    const arr = [...tiendasPendientes];
    [arr[index + 1], arr[index]] = [arr[index], arr[index + 1]];
    setTiendasPendientes(arr);
  };

  const removeTiendaPendiente = (index) => {
    setTiendasPendientes(prev => prev.filter((_, i) => i !== index));
  };

  const drawTiendaNombre = (tienda_id) => {
    const find = cat_tiendas.find(x => x.tienda_id === tienda_id);
    return find ? find.tienda_nombre : "Sin nombre";
  };

  const { chofer_id, descripcion, fecha_salida, hora_salida, viaje_id, chofer, operador } = formatoViaje;
  const onChangeCheck = (event) => {
    setStatus({ ...status, [event.target.name]: event.target.checked });
  };
  /**
   * Valida los datos del formulario
   * @returns boolean
   */
  const validaciones = () => {
    if (tiendasSeleccionadas.length === 0 && tiendasPendientes.length === 0) {
      showToastError("No se ha seleccionado ningún destino");
      setLoading(false);
      return false;
    }

    if (tripulacionSeleccionada.length === 0) {
      showToastError("Favor de seleccionar la tripulación");
      setLoading(false);
      return false;
    }
    const sinRol = tripulacionSeleccionada.filter(x => !x.rol);
    if (sinRol.length > 0) {
      showToastError("Toda la tripulación debe tener un rol asignado");
      setLoading(false);
      return false;
    }
    const operadores = tripulacionSeleccionada.filter(x => x.rol === "OPERADOR");
    if (operadores.length === 0) {
      showToastError("Debe haber al menos un operador");
      setLoading(false);
      return false;
    }

    if (!formatoViaje.hora_salida) {
      showToastError("La hora de salida es obligatoria");
      setLoading(false);
      return false;
    }
    if (!formatoViaje.fecha_salida) {
      showToastError("La fecha de salida es obligatoria");
      setLoading(false);
      return false;
    }

    return true;
  };

  const actualizarTiposTripulantes = async () => {

    const actualizaciones = [];

    for (const seleccionado of tripulacionSeleccionada) {

      const original = tripulantes.find(
        x => x.tripulante_id === seleccionado.tripulante_id
      );

      if (!original) continue;
      const tipoDeseado = seleccionado.rol === "OPERADOR" ? 1 : 2;

      if (original.tipo_tripulante_id !== tipoDeseado) {
        console.log("actualizando trpulante: ", seleccionado.tripulante_id);
        actualizaciones.push(
          putTripulantes(seleccionado.tripulante_id, {
            tipo_tripulante_id: tipoDeseado,
          })
        );
      }
    }

    await Promise.all(actualizaciones);
  };

  const liberarSalida = async () => {
    setLoading(true);

    let flag = validaciones();
    if (!flag) {
      // setLoading(false);
      return;
    }
    const [ok, userId, rolId] = verifyJWT(localStorage.getItem("x-token"));
    let monitorista_id = null;
    let guardia_id = null;
    if (ok) {
      if (rolId === 3) {
        guardia_id = userId;
      } else {
        monitorista_id = userId;
      }
    }

    const operadoresIds = tripulacionSeleccionada
      .filter(x => x.rol === "OPERADOR")
      .map(x => x.tripulante_id);

    await actualizarTiposTripulantes();

    // Guardar tiendas pendientes en orden antes del check
    if (tiendasPendientes.length > 0) {
      for (const tienda_id of tiendasPendientes) {
        await createRuta({ viaje_id, tienda_id });
      }
      const respTiendas = await getTiendasViaje(viaje_id);
      if (respTiendas.ok) setTiendasSeleccionadas(respTiendas.rutas);
      setTiendasPendientes([]);
    }

    let resp = await postCheckPrueba({
      viaje_id: viaje.viaje_id,
      guardia_id: guardia_id,
      monitorista_id: monitorista_id,
      paro_motor: status.first ? 1 : 0,
      boton_panico: status.second ? 1 : 0,
      conectividad: status.third ? 1 : 0,
    });
    if (!resp.ok) {
      // setLoading(false);

      if (resp.msg === "Ya existe el check de pruebas para este viaje") {
        CierraVentana();
        getUnidades();
      }
      setLoading(false);
      return Swal.fire({
        title: "No se pudo crear el check de pruebas",
        text: resp.msg,
        icon: "error",
      });
    }

    const soloTripulantes = tripulacionSeleccionada.filter(x => x.rol === "TRIPULANTE");

    const obj = {
      ...formatoViaje,
      chofer_id: operadoresIds[0] || formatoViaje.chofer_id,
      ...(operadoresIds[1] && { operador_id: operadoresIds[1] }),
      tripulantes: soloTripulantes.map(x => x.tripulante_id),
      fecha_hora_salida: `${formatoViaje.fecha_salida} ${formatoViaje.hora_salida}`,
      fecha_hora_regreso: null,
    };


    // await eliminarTripulacion(viaje_id); // limpiar los anteriores del viaje
    // await postTipulantes({
    //   id_viaje: viaje_id,
    //   tripulantes: soloTripulantes.map(x => ({ tripulante_id: x.tripulante_id })),
    // });

    // resp = await putViaje(obj);
    resp = await putViajev2(obj);
    if (resp.ok) {

      if (!resp.ok) return;

      CierraVentana();
      setDenegoSalida(false);
      setMotivoDenegacionSalida("");
      setTiendasSeleccionadas([]);
      setStatus({
        first: false,
        second: false,
        third: false,
      });
      Swal.fire({
        title: "¡Viaje creado!",
        text: "El viaje ha sido creado con éxito",
        icon: "success",
      });
      await postBitacora({
        id_viaje: viaje.viaje_id,
        notas: "Se aprobó el check de pruebas de la unidad",
        id_status: 3,
      });
      // setLoading(false);
      if (user.roles_id === 2) {
        socket.emit("traer-unidades-en-ruta_", {
          idNegocio: parseInt(unidad.negocio_id),
        });
      } else {
        console.log("traer-unidades-en-ruta_ " + user.negocio_id);
        socket.emit("traer-unidades-en-ruta_", { idNegocio: user.negocio_id });
      }
      await loadInfo();
    }
  };

  const denegarSalida = async () => {
    setLoading(true);
    if (!motivoDenegacionSalida)
      return Swal.fire({ title: "El comentario es requerido", icon: "info" });
    // setLoading(true);

    let respViaje = await getViajeUnidad(unidad.unidad_id);
    // setLoading(false);

    if (!respViaje.ok)
      return Swal.fire({
        title: "¡Viaje no encontrado!",
        text: "No encontramos el viaje de la unidad disponible, intenta más tarde o contacta a telemática",
        icon: "error",
      });

    if (respViaje.status_id === 6 || respViaje.status_id === 5) {
      // si está creado o denegado... deniega la salida
      // setLoading(true);
      let respDenegacion = await postDenegacionViaje({
        viaje_id,
        comentario: motivoDenegacionSalida,
      });

      if (respDenegacion.ok)
        Swal.fire({
          title: "¡Unidad denegada!",
          text: "El viaje ha sido denegado por: " + respDenegacion.comentario,
          icon: "success",
        });
      let resp = await putViajeStatusV2(viaje_id, 9);

      if (resp.ok) {
        CierraVentana();
        setDenegoSalida(false);
        setMotivoDenegacionSalida("");
        setTiendasSeleccionadas([]);
        setStatus({
          first: false,
          second: false,
          third: false,
        });

        await postBitacora({
          id_viaje: viaje.viaje_id,
          notas: "Se denegó la unidad por " + motivoDenegacionSalida,
          id_status: 9,
        });

        socket.emit("traer-unidades-en-ruta_", {
          idNegocio: unidad.negocio_id,
        });

      }
      setLoading(false);

      return;
    }
    setLoading(false);
    CierraVentana();
  };

  const eliminarTripulacion = async (idViaje) => {
    setLoading(true);
    let resp = await deleteTripulacionViaje(idViaje);
    setLoading(false);

    if (!resp.ok)
      return Swal.fire({
        title: "¡Upss!",
        text: "La tripulación del viaje actual no pudo ser removida",
        icon: "error",
      });
  };

  const showToastError = (msj = "Ha ocurrido un error") => {
    toast.error(msj, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  // Función para obtener las opciones de maniobristas
  const obtenerOpcionesManiobristas = (maniobristas, listaTripulantes) =>
    maniobristas
      .filter((x) => x.disponible === 1)
      .map((x) => {
        const find = listaTripulantes.find(
          (y) => y.tripulante_id === x.tripulante_id
        );
        return {
          value: x.tripulante_id,
          label: `${x.nombre_completo} ${x.telefono}`,
          isDisabled: !!find, // Deshabilitar si ya está en la lista de tripulantes
        };
      });

  const ejecutarPruebasSalidaPosition = async () => {
    try {
      console.log("unidad: " + parseInt(unidad.unidad_numero));
      setLoading(true);
      setLoadingPosition(false);
      // Llamada a getPosition 
      const res = await getPositionCamiones(unidad.unidad_id);

      // Si la respuesta es correcta, actualizamos el estado con la fecha de la última posición
      if (res.ok) {
        console.log("regresando position: " + res.fecha_posicion_actual);
        setGps(res.fecha_posicion_actual);
        setGpsEjecutado(true);
        setLoadingPosition(true);
        await ejecutarPruebasSalidaParoMotorOn();
        setLoading(false);
      } else {
        // Si la respuesta no es OK
        console.error("Error al obtener la posición.");
        setLoading(false);
        setLoadingPosition(true);
        setLoadingParoMotorOn(true);
        setLoadingParoMotorOff(true);
        setLoadingPanico(true);
      }
    } catch (error) {
      // Manejo de errores en caso de que falle la solicitud asincrónica
      console.error("Hubo un error al ejecutar las pruebas de salida", error);
      setLoading(false);
      setLoadingPosition(true);
      setLoadingParoMotorOn(true);
      setLoadingParoMotorOff(true);
      setLoadingPanico(true);
    }
  };

  const ejecutarPruebasSalidaParoMotorOn = async () => {
    try {
      console.log("unidad: " + parseInt(unidad.unidad_numero));
      setLoading(true);
      setLoadingParoMotorOn(false);
      // Llamada a getPosition 
      const resp = await ejecutarParoMotor(true, unidad.unidad_id);

      // Si la respuesta es correcta, actualizamos el estado con la fecha de la última posición
      if (resp.ok) {
        console.log("Habilitar motor: " + resp.msg);
        if (resp.resultado.parodemotoron && resp.resultado.parodemotoron.err) {
          setParoMotorOn(resp.resultado.parodemotoron.err ? resp.resultado.parodemotoron.err : resp.msg);
          setParoMotorOnEjecutado(false);
          setLoadingParoMotorOn(true);
          setLoadingParoMotorOff(true);
          setLoadingPanico(true);
        }
        else if (resp.resultado.parodemotoron && resp.resultado.parodemotoron.data.result) {
          setParoMotorOn(resp.resultado.parodemotoron.data.result);
          setParoMotorOnEjecutado(true);
          setLoadingParoMotorOn(true);
          await ejecutarPruebasSalidaParoMotorOff();
        }
        setLoadingParoMotorOn(true);
        setLoading(false);

      } else {
        // Si la respuesta no es OK
        console.error("Error al habilitar el motor.");
        setParoMotorOn(resp.msg);
        setLoading(false);
        setLoadingParoMotorOn(true);
        setLoadingParoMotorOff(true);
        setLoadingPanico(true);
      }
    } catch (error) {
      // Manejo de errores en caso de que falle la solicitud asincrónica
      console.error("Hubo un error al ejecutar las pruebas de salida PM-ON", error);
      setLoading(false);
      setLoadingParoMotorOn(true);
      setLoadingParoMotorOff(true);
      setLoadingPanico(true);
    }
  };

  const ejecutarPruebasSalidaParoMotorOff = async () => {
    try {
      console.log("unidad: " + parseInt(unidad.unidad_numero));
      setLoading(true);
      setLoadingParoMotorOff(false);
      // Ejecuta el paro de motor
      const res = await ejecutarParoMotor(false, unidad.unidad_id);

      // Si la respuesta es correcta
      if (res.ok) {
        console.log("Deshabilitar motor: " + res.msg);
        if (res.resultado.parodemotorof && res.resultado.parodemotorof.err) {
          setParoMotorOff(res.resultado.parodemotorof.err ? res.resultado.parodemotorof.err : res.msg);
          setParoMotorOffEjecutado(false);
          setLoadingParoMotorOff(true);
          setLoadingPanico(true);
        } else
          if (res.resultado.parodemotorof && res.resultado.parodemotorof.data.result) {
            setParoMotorOff(res.resultado.parodemotorof.data.result);
            setParoMotorOffEjecutado(true);
            setLoadingParoMotorOff(true);
            if (paroMotorOnEjecutado) setStatus({ ...status, first: true });
          }

        setLoadingParoMotorOff(true);
        await ejecutarPruebasSalidaBTNPanico();
        setLoading(false);
      } else {
        // Si la respuesta no es OK
        console.error("Error al deshabilitar el motor.");
        setParoMotorOn(res.msg);
        setLoading(false);
        setLoadingParoMotorOff(true);
      }
    } catch (error) {
      // Manejo de errores en caso de que falle la solicitud asincrónica
      console.error("Hubo un error al ejecutar las pruebas de salida PM-OFF", error);
      setLoading(false);
      setLoadingParoMotorOff(false);
    }
  };

  const padToTwoDigits = async (num) => {
    return num.toString().padStart(2, '0');
  }

  const ejecutarPruebasSalidaBTNPanico = async () => {
    try {
      console.log("unidad: " + parseInt(unidad.unidad_numero));
      setLoading(true);
      setLoadingPanico(false);

      let date = new Date();

      // Restar 30 minutos
      const menos30 = new Date(date.getTime() - 30 * 60 * 1000);

      // Definimos los parámetros de búsqueda con la fecha y hora del día actual
      const anio = menos30.getFullYear();
      const mes = String(menos30.getMonth() + 1).padStart(2, '0');
      const dia = String(menos30.getDate()).padStart(2, '0');
      const horas = String(menos30.getHours()).padStart(2, '0');
      const minutos = String(menos30.getMinutes()).padStart(2, '0');
      const segundos = String(menos30.getSeconds()).padStart(2, '0');

      let initialDate = `${anio}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;
      let finalDate = `${anio}-${mes}-${dia} 23:59:59`;
      console.log("datepanico: " + initialDate + "fecha final " + finalDate);
      // Consultamos si existe el panico
      const res = await getBTNPanico(initialDate, finalDate, unidad.unidad_id);

      // Si la respuesta es correcta
      if (res.ok) {
        console.log("Boton de panico ejecutado: " + res.msg);
        setPanico(res.resultado.panico.data.err ? res.resultado.panico.data.err : "Boton de panico ejecutado");
        if (res.resultado.panico.data.err) {
          setPanicoEjecutado(false);
        } else {
          setPanicoEjecutado(true);
        }
        setLoadingPanico(true);
        setLoading(false);
      } else {
        // Si la respuesta no es OK
        console.error("Error al deshabilitar el motor.");
        setLoading(false);
        setLoadingPanico(true);
      }
    } catch (error) {
      // Manejo de errores en caso de que falle la solicitud asincrónica
      console.error("Hubo un error al ejecutar las pruebas de salida PM-OFF", error);
      setLoading(false);
      setLoadingPanico(true);
    }
  };


  return (
    <>
      <div
        className="card display-oculto animated fadeInRight top-0 end-0"
        id="contenedorPruebas"
        style={{ position: "fixed", marginTop: "67px" }}
      >
        {loading && Loader("loader.gif")}
        <div className="card-header" id="card-header">
          Pruebas de salida
          <i className="icono-cerrar">
            <FontAwesomeIcon
              onClick={() => {
                CierraVentana();
                setParoMotorOn("");
                setParoMotorOff("");
                setPanico("");
                setGps("");
                setParoMotorOffEjecutado(false);
                setParoMotorOnEjecutado(false);
                setPanicoEjecutado(false);
                setGpsEjecutado(false);
                setEjecutarPruebas(false);
              }
              }
              style={{ fontSize: 30 }}
              icon={faXmark}
            />
          </i>
        </div>
        <div
          className="card-body"
          style={{ overflowY: "scroll", maxHeight: "700px" }}
        >
          {!denegoSalida ? (
            <>
              <div className="row">
                <div className="col">
                  <b>
                    {unidad.cat_tipos_almacen
                      ? unidad.cat_tipos_almacen.nombre
                      : "Almacén"}
                  </b>
                </div>
                <div className="col">
                  {unidad.cedi ? unidad.cedi.nombre_cedis : "N/A"}
                  {unidad.spot ? (
                    <b className="text-warning mt-n4">
                      {" "}
                      (SPOT {unidad.nombre_transportadora})
                    </b>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr />

              <div className="row">
                <div className="col">
                  <b>UNIDAD</b>
                </div>
                <div className="col">{unidad.unidad_numero}</div>
              </div>
              <hr />

              <div className="row">
                <div className="col">
                  <b>CAJAS</b>
                </div>
                {/* {console.log("Valor de viaje.unidades_cajas ANTES de la condición:", viaje.unidades_cajas)}  */}
                {viaje.unidades_cajas && viaje.unidades_cajas.length > 0 ? (
                  viaje.unidades_cajas.map((x) => {
                    return (
                      <>
                        <div className="col">{x.caja.unidad_numero}</div>
                      </>
                    );
                  })) : (<div className="col">Sin cajas asignadas</div>)}
              </div>
              <hr />

              <div className="row">
                <div className="col">
                  <b>ESTATUS</b>
                </div>
                <div className="col">
                  <strong>{unidad.status && unidad.status.nombre}</strong>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-12">
                  <hr></hr>
                  <h5>Destinos</h5>
                </div>
                <div className="col-12 form-control selectCedis mb-4">
                  <Select
                    options={cat_tiendas.map((x) => {
                      const enGuardadas = tiendasSeleccionadas.find(y => y.tienda_id === x.tienda_id);
                      const enPendientes = tiendasPendientes.find(y => y === x.tienda_id);
                      return {
                        value: x.tienda_id,
                        label: x.tienda_nombre,
                        isDisabled: !!(enGuardadas || enPendientes),
                      };
                    })}
                    className="mb-2"
                    classNamePrefix={"select"}
                    name="destinoSeleccionado"
                    value={destinoSeleccionado}
                    onChange={(elemento) => {
                      agregarTienda(elemento.value);
                    }}
                    placeholder="Selecciona una tienda"
                  />
                </div>
                <div className="col-12">
                  {/* Tiendas ya guardadas en BD - solo se pueden eliminar */}
                  {tiendasSeleccionadas.map((x, index) => (
                    <div className="d-flex align-items-center mb-2 gap-2" key={index}>
                      <span className="badge bg-secondary">{index + 1}</span>
                      <small className="flex-grow-1">{x.tienda ? x.tienda.tienda_nombre : "S/I"}</small>
                      {index === 0 && <span className="badge bg-primary">Inicio</span>}
                      {index === tiendasSeleccionadas.length - 1 && tiendasSeleccionadas.length > 1 && tiendasPendientes.length === 0 && (
                        <span className="badge bg-success">Fin</span>
                      )}
                      <button
                        type="button"
                        onClick={async () => {
                          let resp = await deleteRuta(x.viaje_ruta_id);
                          if (resp.ok) {
                            resp = await getTiendasViaje(viaje_id);
                            if (resp.ok) setTiendasSeleccionadas(resp.rutas);
                          }
                        }}
                        className="btn btn-danger p-0 mb-0"
                        style={{ width: 25, borderRadius: "3rem", height: 25 }}
                      >
                        -
                      </button>
                    </div>
                  ))}

                  {/* Tiendas pendientes con orden editable */}
                  {tiendasPendientes.map((tienda_id, index) => (
                    <div className="d-flex align-items-center mb-2 gap-2" key={`p-${index}`}>
                      <div className="d-flex flex-column">
                        <button type="button" className="btn btn-sm p-0 lh-1"
                          onClick={() => subirTienda(index)} disabled={index === 0 && tiendasSeleccionadas.length === 0}>
                          ▲
                        </button>
                        <button type="button" className="btn btn-sm p-0 lh-1"
                          onClick={() => bajarTienda(index)} disabled={index === tiendasPendientes.length - 1}>
                          ▼
                        </button>
                      </div>
                      <span className="badge bg-secondary">{tiendasSeleccionadas.length + index + 1}</span>
                      <small className="flex-grow-1">{drawTiendaNombre(tienda_id)}</small>
                      {index === 0 && tiendasSeleccionadas.length === 0 && (
                        <span className="badge bg-primary">Inicio</span>
                      )}
                      {index === tiendasPendientes.length - 1 && tiendasPendientes.length > 1 && (
                        <span className="badge bg-success">Fin</span>
                      )}
                      <button type="button" className="btn btn-sm p-0"
                        onClick={() => removeTiendaPendiente(index)}>
                        <FontAwesomeIcon icon={faXmark} style={{ color: "red" }} />
                      </button>
                    </div>
                  ))}

                  {tiendasSeleccionadas.length === 0 && tiendasPendientes.length === 0 && (
                    <p className="text-warning text-center">
                      <small>La unidad no tiene ningún destino seleccionado</small>
                    </p>
                  )}
                  <hr></hr>
                  <label className="mt-3">Fecha de salida</label>
                  <Input
                    attribute={{
                      name: "fecha_salida",
                      type: "date",
                      className: "form-control control-input mb-3",
                      required: "required",
                      id: "fecha_salida",
                    }}
                    value={fecha_salida}
                    onChange={handleChange}
                  />
                  <label>Hora de salida</label>
                  <Input
                    attribute={{
                      name: "hora_salida",
                      type: "time",
                      className: "form-control control-input mb-3",
                      required: "required",
                      id: "hora_salida",
                    }}
                    value={hora_salida}
                    onChange={handleChange}
                  />
                  <hr></hr>
                  <label>Tripulación</label>
                  <Select
                    isMulti
                    options={tripulantes.map((x) => {
                      const yaSeleccionado = tripulacionSeleccionada.find(
                        y => y.tripulante_id === x.tripulante_id
                      );
                      return {
                        value: x.tripulante_id,
                        label: `${x.nombre_completo} ${x.telefono}`,
                        data: x,
                        isDisabled:
                          x.ocupado ||
                          (tripulacionSeleccionada.length >= 4 && !yaSeleccionado),
                      };
                    })}
                    className="mb-2"
                    classNamePrefix={"select"}
                    placeholder="Selecciona tripulación"
                    value={tripulacionSeleccionada.map(p => ({
                      value: p.tripulante_id,
                      label: `${p.nombre} ${p.telefono}`,
                      data: p,
                    }))}
                    noOptionsMessage={({ inputValue }) => (
                      <button
                        className="btn btn-sm mb-2"
                        type="button"
                        onClick={() => setShowModalCrud(true)}
                      >
                        <strong>+ AGREGAR TRIPULANTE "{inputValue}"</strong>
                      </button>
                    )}
                    onChange={(elementos) => {
                      const nuevaLista = elementos.map((x) => {
                        const existente = tripulacionSeleccionada.find(
                          y => y.tripulante_id === x.value
                        );
                        return {
                          tripulante_id: x.value,
                          nombre: x.data?.nombre_completo || x.data?.nombre || "",
                          telefono: x.data?.telefono || "",
                          rol: existente?.rol || null,
                          tipo_tripulante_id: x.data?.tipo_tripulante_id,
                        };
                      });
                      setTripulacionSeleccionada(nuevaLista);
                    }}
                  />

                  {tripulacionSeleccionada.map((persona) => {
                    const operadores = tripulacionSeleccionada.filter(x => x.rol === "OPERADOR");
                    const tripulantesRol = tripulacionSeleccionada.filter(x => x.rol === "TRIPULANTE");

                    return (
                      <div className="card p-3 mb-2" key={persona.tripulante_id}>
                        <div className="row">
                          <div className="col-12 text-center">
                            <strong className="fs-6">{persona.nombre}</strong>
                            <br />
                            <small className="text-muted">{persona.telefono}</small>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-12">
                            <div className="d-flex justify-content-center gap-2">
                              <button
                                type="button"
                                style={{ padding: "5px" }}
                                className={persona.rol === "OPERADOR" ? "btn btn-primary" : "btn btn-outline-primary"}
                                onClick={() => {
                                  if (operadores.length >= 2 && persona.rol !== "OPERADOR") {
                                    return Swal.fire({ icon: "warning", text: "Solo puedes seleccionar máximo 2 operadores" });
                                  }
                                  setTripulacionSeleccionada(
                                    tripulacionSeleccionada.map(x =>
                                      x.tripulante_id === persona.tripulante_id ? { ...x, rol: "OPERADOR", tipo_tripulante_id: 1 } : x
                                    )
                                  );
                                }}
                              >
                                Conductor
                              </button>
                              <button
                                type="button"
                                style={{ padding: "5px" }}
                                className={persona.rol === "TRIPULANTE" ? "btn btn-success" : "btn btn-outline-success"}
                                onClick={() => {
                                  if (tripulantesRol.length >= 2 && persona.rol !== "TRIPULANTE") {
                                    return Swal.fire({ icon: "warning", text: "Solo puedes seleccionar máximo 2 tripulantes" });
                                  }
                                  setTripulacionSeleccionada(
                                    tripulacionSeleccionada.map(x =>
                                      x.tripulante_id === persona.tripulante_id ? { ...x, rol: "TRIPULANTE", tipo_tripulante_id: 2 } : x
                                    )
                                  );
                                }}
                              >
                                Acompañante
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <hr />
                  <label>Observaciones</label>
                  <textarea
                    className="form-control"
                    name={"descripcion"}
                    value={descripcion}
                    onChange={handleChange}
                  ></textarea>
                  <hr />
                  <div className="col-12">
                    {
                      user.roles_id !== 8 && (status.first === false || status.second === false || status.third === false) ? (
                        <button
                          className="btn btn-primary"
                          style={{ width: "100%" }}
                          onClick={async () => {
                            setEjecutarPruebas(true);
                            ejecutarPruebasSalidaPosition();
                            setHabilitado(false);
                          }}
                          disabled={!habilitado}
                        >Ejecutar pruebas de salida
                        </button>
                      ) : ""
                    }
                    {
                      ejecutarPruebas === true ?
                        (
                          <>
                            <table className="table">
                              <thead>
                                <tr>
                                  <th scope="col">Evento</th>
                                  <th scope="col">Respuesta</th>
                                  <th scope="col">Acciones</th>
                                </tr>
                              </thead>
                              <tbody className="table-group-divider">
                                <tr>
                                  <td>GPS</td>
                                  <td>{gps}</td>
                                  <td>
                                    {
                                      loadingPosition === false ? (
                                        <>
                                          <div className="text-center">
                                            <Spinner animation="border" variant="primary"></Spinner>
                                          </div>
                                        </>
                                      ) :
                                        gps !== "" ?
                                          (
                                            <>
                                              <FontAwesomeIcon
                                                style={{ fontSize: 30, float: "right" }}
                                                icon={faCheck}
                                              />
                                            </>
                                          ) : (
                                            <>
                                              <button
                                                className="btn btn-primary"
                                                onClick={() => ejecutarPruebasSalidaPosition()}
                                              >Ejecutar
                                              </button>
                                            </>
                                          )
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td>Activar paro de motor</td>
                                  <td>{paroMotorOn}</td>
                                  <td>
                                    {

                                      loadingParoMotorOn === false ? (
                                        <>
                                          <div className="text-center">
                                            <Spinner animation="border" variant="primary"></Spinner>
                                          </div>
                                        </>
                                      ) :
                                        paroMotorOnEjecutado ? (
                                          <>
                                            <FontAwesomeIcon
                                              style={{ fontSize: 30, float: "right" }}
                                              icon={faCheck}
                                            />
                                          </>
                                        ) : (
                                          <>
                                            <button
                                              className="btn btn-primary"
                                              onClick={() => ejecutarPruebasSalidaParoMotorOn()}
                                            >Ejecutar
                                            </button>
                                          </>
                                        )
                                    }

                                  </td>
                                </tr>
                                <tr>
                                  <td>Desactivar paro de motor</td>
                                  <td>{paroMotorOff}</td>
                                  <td>
                                    {
                                      loadingParoMotorOff === false ? (
                                        <>
                                          <div className="text-center">
                                            <Spinner animation="border" variant="primary"></Spinner>
                                          </div>
                                        </>
                                      ) :
                                        paroMotorOffEjecutado ? (
                                          <>
                                            <FontAwesomeIcon
                                              style={{ fontSize: 30, float: "right" }}
                                              icon={faCheck}
                                            />
                                          </>
                                        ) : (
                                          <>
                                            <button
                                              className="btn btn-primary"
                                              onClick={() => ejecutarPruebasSalidaParoMotorOff()}
                                            >Ejecutar
                                            </button>
                                          </>
                                        )
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td>Boton de Panico</td>
                                  <td>{panico}</td>
                                  <td>
                                    {
                                      loadingPanico === false ? (
                                        <>
                                          <div className="text-center">
                                            <Spinner animation="border" variant="primary"></Spinner>
                                          </div>
                                        </>
                                      ) :
                                        panico !== "" && panicoEjecutado ?
                                          (
                                            <>
                                              <FontAwesomeIcon
                                                style={{ fontSize: 30, float: "right" }}
                                                icon={faCheck}
                                              />
                                            </>
                                          ) : (
                                            <>
                                              <button
                                                className="btn btn-primary"
                                                onClick={() => ejecutarPruebasSalidaBTNPanico()}
                                              >Ejecutar
                                              </button>
                                            </>
                                          )
                                    }

                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </>
                        ) : ""
                    }
                  </div>
                </div>
              </div>
              <br />
              <hr />

              {
                user.roles_id !== 8 && (
                  <>
                    {unidad.spot ? (
                    <>
                      <div className="form-check form-switch">
                        <label
                          className="form-check-label"
                          htmlFor="flexSwitchCheckDefault3"
                        >
                          GPS ACTUALIZANDO
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          aria-checked="false"
                          name="third"
                          checked={status.third}
                          onChange={onChangeCheck}
                          id="flexSwitchCheckDefault3"
                        />
                      </div>
                    </>
                    ) : (
                    <>
                      <div className="form-check form-switch">
                        <label
                          className="form-check-label"
                          htmlFor="flexSwitchCheckDefault"
                        >
                          PARO DE MOTOR
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          aria-checked="false"
                          name="first"
                          checked={status.first}
                          onChange={onChangeCheck}
                          id="flexSwitchCheckDefault"
                        />
                      </div>
                      <div className="form-check form-switch">
                        <label
                          className="form-check-label"
                          htmlFor="flexSwitchCheckDefault1"
                        >
                          BOTÓN DE PÁNICO
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          aria-checked="false"
                          name="second"
                          checked={status.second}
                          onChange={onChangeCheck}
                          id="flexSwitchCheckDefault1"
                        />
                      </div>
                      <div className="form-check form-switch">
                        <label
                          className="form-check-label"
                          htmlFor="flexSwitchCheckDefault3"
                        >
                          GPS ACTUALIZANDO
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          aria-checked="false"
                          name="third"
                          checked={status.third}
                          onChange={onChangeCheck}
                          id="flexSwitchCheckDefault3"
                        />
                      </div>
                    </>
                    )}
                  </>
                )

              }


              <div className="row">
                <button
                  id="liberarSalida"
                  type="button"
                  className="btn btn-yellow btn-block liberarSalida"
                  disabled={
                    loading
                      ? true
                      : status.first || status.second || status.third
                        ? false
                        :  user.roles_id === 8 ? false
                        : true
                  }
                  onClick={liberarSalida}
                >
                  <span>
                    <img src={carroIcono} width="8%" alt=""></img>{" "}
                  </span>
                  &nbsp; Liberar salida
                </button>
                <button
                  type="button"
                  disabled={loading}
                  className="btn btn-block text-white liberarSalida"
                  style={{ background: "#2E333B" }}
                  onClick={() => {
                    setDenegoSalida(true);
                  }}
                >
                  <span>
                    {" "}
                    <img src={denegadaIcono} width="8%" alt=""></img>{" "}
                  </span>
                  &nbsp; Denegar salida
                </button>
              </div>
            </>
          ) : (
            <form
              onSubmit={(event) => {
                event.preventDefault();
              }}
            >
              <label>¿Cuál es el motivo de la denegación?</label>
              <input
                className="form-control mt-3"
                value={motivoDenegacionSalida}
                onChange={(event) => {
                  setMotivoDenegacionSalida(event.target.value);
                }}
              />
              <button
                type="button"
                className="btn btn-outline-secondary my-3 col-12"
                onClick={denegarSalida}
                disabled={loading}
              >
                Denegar salida
              </button>
              <button
                type="button"
                className="btn btn-danger btn-block liberarSalida"
                disabled={loading}
                onClick={() => {
                  setDenegoSalida(false);
                }}
              >
                Cancelar
              </button>
            </form>
          )}{" "}
        </div>
      </div>
      {/* Same as */}
      <EditCreateTripulante
        negocio_id={unidad.negocio_id}
        show={showModalCrud}
        handleClose={() => setShowModalCrud(false)}
        refreshTripulantes={async () => { await loadInfo(); }}
      />
    </>
  );
};
